import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

export const NotFoundPage = (): React.ReactElement => {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="صفحه پیدا نشد"
      subTitle="آدرس واردشده معتبر نیست یا صفحه جابه‌جا شده است."
      extra={<Button type="primary" onClick={() => navigate('/dashboard')}>بازگشت به داشبورد</Button>}
    />
  );
};
